// A chart waiting on its data plays a slow stereo equalizer in its own series styles: each bar
// drifts from where it stands and a line rises and falls as a whole. The value axis is pinned
// to 0–1 and unlabeled, so nothing on screen reads as a figure.

export const EQUALIZER_STEP_MS = 1600
const MOVE_MS = 1200
// Bars start their moves at scattered moments, each finishing before the next step.
const STAGGER_MS = EQUALIZER_STEP_MS - MOVE_MS
// Appreciation's ten years, before the data names them.
const PLACEHOLDER_CATEGORIES = 10

const BAR_LOW = 0.12
const BAR_HIGH = 0.88
const BAR_DRIFT = 0.28
const LINE_MIDDLE = 0.42
const LINE_ARC = 0.1

const between = (low, high) => low + Math.random() * (high - low)
const clamp = (value, low, high) => Math.min(Math.max(value, low), high)

export function equalizerOptions(options) {
  const categories = options.xAxis.data.length > 0 ? options.xAxis.data : Array(PLACEHOLDER_CATEGORIES).fill("")
  return {
    ...options,
    tooltip: {show: false},
    xAxis: {...options.xAxis, data: categories},
    yAxis: {...options.yAxis, min: 0, max: 1, axisLabel: {show: false}},
    animationDurationUpdate: MOVE_MS,
    animationEasingUpdate: "sinusoidalInOut",
    animationDelayUpdate: () => between(0, STAGGER_MS),
    series: options.series.map((series) => ({
      ...series,
      label: {show: false},
      data: series.type === "line"
        ? arc(categories.length, LINE_MIDDLE)
        : categories.map(() => between(BAR_LOW, BAR_HIGH))
    }))
  }
}

// The next step from the frame on screen.
export function equalizerFrame(series) {
  return series.map(({type, data}) => ({data: type === "line" ? swung(data) : data.map(drifted)}))
}

function drifted(bar) {
  return clamp(bar + between(-BAR_DRIFT, BAR_DRIFT), BAR_LOW, BAR_HIGH)
}

// A gentle hump, lowest at both ends, so its first point is the line's level.
function arc(count, level) {
  return Array.from({length: count}, (_, index) => level + LINE_ARC * Math.sin(Math.PI * index / (count - 1)))
}

// The line crosses its middle every step, by a different amount each time.
function swung(line) {
  const level = line[0]
  const target = LINE_MIDDLE + (level > LINE_MIDDLE ? -1 : 1) * between(0.05, 0.15)
  return line.map((point) => point + target - level)
}
